import { render, staticRenderFns } from "./cashBoxesTrash.vue?vue&type=template&id=ee0f93d4&scoped=true&"
import script from "./cashBoxesTrash.vue?vue&type=script&lang=js&"
export * from "./cashBoxesTrash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0f93d4",
  null
  
)

export default component.exports